<template>
  <div>
    <div class="filter-bar mb-sm">
      <breadcrumb></breadcrumb>

      <div class="space"></div>

      <el-button size="small" type="primary" @click="onView"
        >查看手册</el-button
      >
      <el-button slot="reference" size="small" @click="$router.go(-1)"
        >返回</el-button
      >
    </div>
    <div v-loading="loading" class="content-box">
      <div>
        <h2 class="label">小组名称：</h2>
        <span> {{ groupInfo?.groupName }}</span>
      </div>
      <div>
        <h2 class="label">学年：</h2>
        <span> {{ groupInfo?.schoolYear }}</span>
      </div>
      <div>
        <h2 class="label">学期：</h2>
        <span> {{ groupInfo?.schoolTerm | revertTerm }}</span>
      </div>
      <div>
        <h2 class="label">主持人：</h2>
        <span> {{ groupInfo?.leaderName }}</span>
      </div>
      <div>
        <h2 class="label">类型：</h2>
        <span> {{ groupInfo?.groupType | revertType }}</span>
      </div>
      <div>
        <h2 class="label">成员：</h2>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="userName" label="姓名"> </el-table-column>
        <el-table-column prop="teacherInfoList" label="学科">
          <template slot-scope="scope">
            {{ scope.row.teacherInfoList | revertTeacherInfoList }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="userDutyDesc" label="学历">
          <template slot-scope="scope">
            {{ scope.row.teacherArchivesDTO?.educationDesc }}
          </template>
        </el-table-column> -->
        <el-table-column prop="teachingAge" label="教龄">
          <template slot-scope="scope">
            {{ scope.row.teacherArchivesDTO?.teachingAge }}
          </template>
        </el-table-column>
        <el-table-column prop="userDutyDesc" label="职称（务）">
          <template slot-scope="scope">
            {{ scope.row.teacherArchivesDTO?.academicTitlesDesc }}</template
          >
        </el-table-column>
        <el-table-column prop="remark" label="备注">
          <template slot-scope="scope">
            {{
              scope.row.teacherArchivesDTO?.remark &&
              JSON.parse(scope.row.teacherArchivesDTO.remark)
                ?.researchProjectRemark
            }}</template
          >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="goEditInfo(scope.row)"
              >编辑</el-button
            >
            <el-popconfirm title="确定删除吗？" @confirm="onDel(scope.row)">
              <el-button
                slot="reference"
                type="text"
                class="danger"
                size="small"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="编辑备注"
        :visible.sync="dialogShow"
        @closed="onDialogClose"
      >
        <el-form
          v-loading="saving"
          ref="dialogForm"
          :model="dialogForm"
          :rules="rules"
        >
          <el-form-item label="姓名" prop="userName">
            <el-input
              :bordered="false"
              readonly
              v-model="dialogForm.userName"
            ></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="userCode">
            <el-input
              :bordered="false"
              readonly
              v-model="dialogForm.userCode"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              clearable
              maxlength="200"
              show-word-limit
              v-model="dialogForm.remark"
              placeholder="请输入"
            ></el-input> </el-form-item
        ></el-form>
        <div slot="footer" class="dialog-footer text-center">
          <el-button @click="dialogShow = false">取 消</el-button>
          <el-button type="primary" @click="onSave" :loading="saving"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { postData } from "@/http/fetch";
import { mapState } from "vuex";
import { postJson } from "../../../http/fetch";
import Breadcrumb from "@/components/Breadcrumb.vue";

export default {
  components: {
    Breadcrumb,
  },
  filters: {
    revertType(val) {
      switch (val) {
        case "sx":
          return "四薪";
        case "sp":
          return "三品";
        case "ef":
          return "二访";
      }
    },
    revertTerm(val) {
      switch (val) {
        case 1:
          return "上学期";
        case 2:
          return "下学期";
      }
    },
    revertTeacherInfoList(val) {
      return Array.from(new Set(val?.map((item) => item.disciplineName))).join(
        "，"
      );
    },
  },
  data() {
    return {
      groupInfo: null,
      loading: false,
      dialogShow: false,
      saving: false,
      tableData: [],
      groupCode: "",
      dialogForm2: null,
      dialogForm: {
        userName: null,
        userCode: null,
        remark: null,
      },
      rules: {
        remark: [{ required: true, message: "请输入备注", trigger: "change" }],
      },
    };
  },
  computed: {
    ...mapState(["userInfo", "isAdmin"]),
  },
  mounted() {
    if (sessionStorage.getItem("groupCode")) {
      this.groupCode = sessionStorage.getItem("groupCode");
      this.getDeatail(this.groupCode);
      this.getProjectGroupTeacherList(this.groupCode);
    }
  },
  methods: {
    onDialogClose() {
      this.$refs.dialogForm.resetFields();
    },
    onView() {
      this.$router.push({
        name: "researchProjectHandbook",
      });
    },
    onSave() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          postJson("/user/updateTeacherArchives", {
            id: this.dialogForm2.teacherArchivesDTO.id,
            operatorId: this.userInfo.userId,
            remark: this.dialogForm2.teacherArchivesDTO.remark
              ? JSON.stringify({
                  ...JSON.parse(this.dialogForm2.teacherArchivesDTO.remark),
                  researchProjectRemark: this.dialogForm.remark,
                })
              : JSON.stringify({
                  researchProjectRemark: this.dialogForm.remark,
                }),
            schoolCodes: this.schoolCodes,
            userId: this.dialogForm2.userId,
          })
            .then((res) => {
              this.dialogShow = false;
              this.$message.success("操作成功！");
              this.getProjectGroupTeacherList(this.groupCode);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.saving = false;
            });
        }
      });
    },
    goEditInfo(row) {
      this.dialogForm2 = row;
      this.dialogForm.userName = row.userName;
      this.dialogForm.userCode = row.userCode;
      if (row.teacherArchivesDTO.remark) {
        this.dialogForm.remark = JSON.parse(
          row.teacherArchivesDTO.remark
        )?.researchProjectRemark;
      }
      this.dialogShow = true;
    },
    async getDeatail(groupCode) {
      this.loading = true;
      await postData("/projectGroup/getProjectGroupInfo", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.groupInfo = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getProjectGroupTeacherList(groupCode) {
      this.loading = true;
      await postData("/projectGroup/getProjectGroupTeacherList", {
        schoolCode: this.userInfo.schoolCode,
        groupCode,
      })
        .then((res) => {
          this.tableData = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onDel(row) {
      this.saving = true;
      postData("/projectGroup/deleteProjectGroupTeacher", {
        groupCode: this.groupCode,
        userId: row.userId,
      })
        .then((res) => {
          this.getProjectGroupTeacherList(this.groupCode);
          this.$message.success("删除成功！");
        })
        .catch((e) => {})
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.content-box {
  background-color: #fff;
  padding: 20px;
  > div {
    font-size: 16px;
    margin: 10px 0;
    display: flex;
    .label {
      width: 100px;
    }
  }
  &:last-child .el-table {
    display: block;
  }
}
</style>